import groupBy from "lodash/groupBy";
import { useMemo } from "react";

export default function useGroupBy(array = [], key) {
	return useMemo(() => groupBy(array, key), [array, key]);
}
